import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { ValueStub } from 'constants/data';

import {
  clampedTextStyles,
  numberChipStyles,
  titleRowStyles,
  titleTextStyles,
  wrapperStyles,
} from './ConditionCell.styles';
import { getAddedMetaLabel } from './ConditionCell.utils';

const ConditionCell = ({ number, title, message, addedBy, addedDate }) => {
  const primaryText = title || message;
  const showSecondaryMessage = !!title && !!message && message !== title;
  const addedMeta = getAddedMetaLabel({ addedBy, addedDate });
  const hasNumber = !!number && number !== ValueStub.ALTERNATE;

  return (
    <Box sx={wrapperStyles}>
      <Box sx={titleRowStyles}>
        {hasNumber ? (
          <Typography sx={numberChipStyles} variant="medium12">
            {`#${number}`}
          </Typography>
        ) : null}
        <Typography
          data-truncated
          color="text.primary"
          sx={title ? titleTextStyles : clampedTextStyles}
          variant="medium14"
        >
          {primaryText}
        </Typography>
      </Box>

      {showSecondaryMessage && (
        <Typography color="text.secondary" sx={clampedTextStyles} variant="regular12">
          {message}
        </Typography>
      )}

      {addedMeta && (
        <Typography color="text.secondary" variant="regular12">
          {addedMeta}
        </Typography>
      )}
    </Box>
  );
};

ConditionCell.propTypes = {
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.string,
  message: PropTypes.string,
  addedBy: PropTypes.string,
  addedDate: PropTypes.string,
};

export default memo(ConditionCell);
